import { STORAGE } from '@webready/shared/config';

const DESIGN_CUSTOM_CACHE_KEY = STORAGE.keys.designCustom;

export function readDesignCustomCache(): boolean {
  try {
    return sessionStorage.getItem(DESIGN_CUSTOM_CACHE_KEY) === '1' ||
           localStorage.getItem(DESIGN_CUSTOM_CACHE_KEY) === '1';
  } catch {
    return false;
  }
}

export function cacheDesignCustomFlag(enabled: boolean) {
  try {
    sessionStorage.setItem(DESIGN_CUSTOM_CACHE_KEY, enabled ? '1' : '0');
    localStorage.setItem(DESIGN_CUSTOM_CACHE_KEY, enabled ? '1' : '0');
  } catch {
    /* ignore */
  }
}
